import { Injectable, OnDestroy } from '@angular/core';
import { OrgEntityService } from '@app/shared/services/org-entity.service';
import { Dashboard } from '@entities/dashboard';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { State } from '@app/app.state';
import { EntityService } from '@app/shared/services/entity.service';
import { getOrganizationId } from '@app/user-org/state/user-org.selectors';
import { COLLECTION_NAMES } from '@app/shared/services/collection-names';

@Injectable()
export class DashboardService implements EntityService<Dashboard> {
   entities$: Observable<Dashboard[]>;

   readonly COLLECTION_NAME = COLLECTION_NAMES.DASHBOARDS;

   private orgId$: Observable<string> = this.store.pipe(select(getOrganizationId));
   private orgEntityService = new OrgEntityService<Dashboard>();

   constructor(private store: Store<State>) {
      this.orgEntityService.init(this.orgId$, this.COLLECTION_NAME);
      this.entities$ = this.orgEntityService.entities$;
   }

   save(entity: Dashboard): Promise<Dashboard> {
      return this.orgEntityService.save(entity);
   }
   batchSave(entities: Dashboard[]): Promise<Dashboard[]> {
      return this.orgEntityService.batchSave(entities);
   }
   delete(entity: Dashboard): Promise<void> {
      return this.orgEntityService.delete(entity);
   }
}
